import { http } from '../index';

export const getEventsList = params =>
  http
    .get('/events/list', { params })
    .then(res => res.data)
    .catch(error => error.response?.data || error);

export const deleteEvent = id =>
  http
    .delete(`/events/${id}`)
    .then(res => res.data)
    .catch(error => error.response?.data || error);

export const bulkDeleteEvents = ids =>
  http
    .post('/events/bulk/delete', { ids })
    .then(res => res.data)
    .catch(error => error.response?.data || error);

const eventsApi = {
  getEventsList,
  deleteEvent,
  bulkDeleteEvents,
};

export default eventsApi;
